import { render, staticRenderFns } from "./GlobalTrumbowyg.vue?vue&type=template&id=2b0ad24b"
import script from "./GlobalTrumbowyg.vue?vue&type=script&lang=js"
export * from "./GlobalTrumbowyg.vue?vue&type=script&lang=js"
import style0 from "./GlobalTrumbowyg.vue?vue&type=style&index=0&id=2b0ad24b&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports